export default function timeAgo(date, short) {
  const currentDate = new Date();
  const timestamp = date.getTime();
  const currentTimestamp = currentDate.getTime();
  const difference = Math.max((currentTimestamp - timestamp), 0);

  // Define time intervals in milliseconds
  const minute = 60 * 1000;
  const hour = minute * 60;
  const day = hour * 24;
  const week = day * 7;

  // Calculate time difference in different units
  const weeks = Math.floor(difference / week);
  const days = Math.floor((difference % week) / day);
  const hours = Math.floor((difference % day) / hour);
  const minutes = Math.floor((difference % hour) / minute);
  const seconds = Math.floor((difference % minute) / 1000);

  // Choose the appropriate unit and format the result
  if (weeks > 0) {
    if (short) return `${weeks}w`;
    return weeks === 1 ? '1 week ago' : `${weeks} weeks ago`;
  } else if (days > 0) {
    if (short) return `${days}d`;
    return days === 1 ? '1 day ago' : `${days} days ago`;
  } else if (hours > 0) {
    if (short) return `${hours}h`;
    return hours === 1 ? '1 hour ago' : `${hours} hours ago`;
  } else if (minutes > 0) {
    if (short) return `${minutes}m`;
    return minutes === 1 ? '1 minute ago' : `${minutes} minutes ago`;
  } else {
    if (short) return `now`;
    return `now`;
  }
}
